import * as React from "react";
import { isPlainObject } from "remeda";
export function isReactContext2(variable) {
    return isPlainObject(variable) && React.isValidElement(variable.Provider) && React.isValidElement(variable.Consumer);
}
export const isReactContext = (variable)=>{
    return isPlainObject(variable) && // @ts-expect-error $$typeof is a private property
    variable.$$typeof === React.createContext(null).$$typeof;
};
